import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyJakZamawiac() {
  return <ArticleLayout article={articlesBySlug['kakobuy-jak-zamawiac-z-chin']} />;
}